var exports = {
  "x6": "GuildListActionButton.module__button___Z3ZSc2",
  "td": "GuildListActionButton.module__iconText___Z3ZSc2",
  "ro": "GuildListActionButton.module__menuIcon___Z3ZSc2",
};

module.exports = exports;
